import { Box, Stack, styled } from '@/shared/ui';
import { Button } from '@/shared/ui/lib/Button';

export const StyledContainer = styled(Box)`
  background-color: transparent;
  padding: 0;
  border-radius: 0;
  margin-bottom: 0;
`;

export const StyledFormContainer = styled(Stack)`
  position: relative;
  width: min(100%, 520px);
`;

export const StyledButton = styled(Button)`
  position: static;
  min-width: 128px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
  }
`;
